// helpers/productLinks.js

const productLinks = [
    {
        category: "Indian Basmati Rice",
        desc: `Indian Basmati Rice is a premium long-grain rice variety known for its unique aroma, delicate flavor, and slender grains.
        It is primarily grown in the Himalayan region of India and is highly regarded for its quality and culinary versatility.
        Basmati rice is often used in traditional Indian dishes such as biryani, pulao, and various rice-based recipes.
        The grains are known for their ability to remain separate and fluffy when cooked, making them ideal for a wide range of cuisines.
        Indian Basmati Rice is available in various forms, including raw, steamed, and parboiled (sella), each with its own distinct characteristics.
        It is a staple in Indian households and is also exported worldwide, making it a popular choice for rice lovers globally.`,
        items: [
            {
                name: "1121 Basmati Rice",
                desc: `The key grain characteristics is, it has extra-long slender grains with a milled rice kernel length. 
                        Also, the kernel elongation ratio is also the highest ever known for any rice line. It also possesses the strong aroma with excellent cooking in the panel test. 
                        The volume expansion in the cooked rice is more than 4.0 times thus it helps in realizing more cooked rice volume with lesser milled rice,
                        a trait most preferred in the household as well as the most preferable hotel industry.`,
                slug: "1121-basmati Rice",
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747386164/1121Sella-Rice_yc7rnp.png",
                subitems: [
                    {
                        name: "1121 Raw Basmati",
                        desc: `1121 Raw Basmati Rice is a highly regarded and sought-after variety of rice known for its exceptional quality and unique characteristics. 
                               It is a long-grain rice variety that is native to the Indian subcontinent and is particularly famous for its aromatic fragrance,
                               delicate flavor, and slender, elongated grains. Here's a detailed description of 1121 Raw Basmati Rice:`,
                        Specification: [
                            { "Purity": "95% Max" },
                            { "Natural Admixture": "14% Max" },
                            { "Average Grain Length": "8.35 MM" },
                            { "Moisture": "12.5% Max" },
                            { "Broken Grain": "1% Max" },
                            { "Damage/Discolour Grain": "1% Max" },
                            { "Immature Grain": "1% Max" },
                            { "Foreign Matter": "Nil" }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        slug: "1121-Raw-Basmati",
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629689/1121-Raw-Rice_hy5jfa.jpg",
                    },
                    {
                        name: "1121 Golden Sella Basmati",
                        desc: `The distinguishing feature of 1121 Golden Sella Basmati Rice is its golden-yellow appearance. This color results from a specialized parboiling process,
                                which involves partially boiling the rice in the husk before milling. This process ensures that the nutrients are retained within the grain, 
                                giving it a robust flavor and a characteristic golden color. The long, slender grains are a testament to its premium quality.
                                Flavor and Texture: When it comes to taste and texture, 1121 Golden Sella Basmati Rice stands out. It offers a delightful blend of flavors - nutty, earthy,
                                and slightly floral. The grains remain separate and non-sticky after cooking, making it a preferred choice for biryanis, pilafs, and other rice dishes.
                                Its exceptional elongation upon cooking makes it perfect for presenting visually appealing dishes.`,

                        Specification: [
                            { "Purity": "95%" },
                            { "Natural Admixture": "5%" },
                            { "Average Grain Length": "8.35MM" },
                            { "Moisture": "12.5% Max" },
                            { "Broken Grain": "1%" },
                            { "Damage/Discolour Grain": "1%" },
                            { "Immature Grain": "1%" },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, Non-woven bag or as per buyer's choice" }
                        ],

                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        slug: "1121-golden-sella-basmati-rice",
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629695/1121-Golden-Sella_tp7mog.jpg",
                    },
                    {
                        name: "1121 Sella Basmati",
                        slug: "1121-sella-basmati",
                        desc: `1121 Sella Basmati Rice is a specific variety of Basmati rice known for its long grains, aromatic fragrance, and excellent cooking qualities.
                                Here's a breakdown of what this term means:
                                Basmati Rice: Basmati rice is a type of long-grain rice primarily grown in the Indian subcontinent. It is highly regarded for its distinct aroma, 
                                elongated grains, and delicate flavor. Basmati rice is a staple in many Indian and South Asian cuisines.
                                1121: The number "1121" in the name refers to a particular Basmati rice cultivar that has been developed through traditional breeding techniques.
                                Each Basmati variety has unique characteristics, and 1121 is known for its extra-long grain length.
                                Sella: "Sella" is a term used to describe parboiled rice. Parboiled rice is rice that has been partially boiled in its husk, which helps retain some of the nutrients 
                                from the outer layers of the rice grain. Sella Basmati Rice, including 1121 Sella Basmati Rice, undergoes a parboiling process.`,

                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.35 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, Non-woven bag or as per buyer's choice" }
                        ],

                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629689/1121-Raw-Rice_hy5jfa.jpg",
                    },

                    {
                        name: "1121 Steam Basmati",
                        slug: "1121-steam-basmati",
                        desc: `1121 Steam Basmati Rice is a popular choice for both everyday meals and special occasions. It is versatile and can be used to make a variety of dishes, 
                                including biryani, pilaf, pulao, and fried rice. It is also a good choice for risotto and other creamy rice dishes.
                                Here are some of the key characteristics of 1121 Steam Basmati Rice:
                                - Long, slender grains
                                - Soft texture
                                - Pronounced nutty flavor
                                - Good source of fiber and protein
                                - Versatile and can be used in a variety of dishes
                                To cook 1121 Steam Basmati Rice, simply rinse the rice in cold water until the water runs clear. 
                                Then, add the rice to a pot of boiling water and reduce the heat to low. Cover the pot and simmer for 12-15 minutes, or until the rice is cooked through. 
                                Once the rice is cooked, remove it from the heat and let it stand for 5 minutes before fluffing it with a fork.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.35mm" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, Non-woven bag or  as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629688/1121-Sella-Rice_kscsx3.jpg",
                    }
                ],
            },
            {
                name: "1509 Basmati Rice",
                slug: "1509-basmati-rice",
                desc: `
                    1509 Basmati Rice variety has the longest grain, which can go up to 8.5 mm. 1509 rice is cheaper in comparison to 1121 rice variety because 1509 rice's
                    cultivation time is less and produces higher yield as compared to 1121 rice. Upon cooking, 
                    the grains exhibit great elongation, excellent fluffiness, are non-sticky and have a pleasant aroma.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629691/1509-Raw-Rice_aick8u.jpg",
                subitems: [
                    {
                        name: "1509 Steam Basmati Rice",
                        slug: "1509-stream-basmati-rice",
                        desc: `1509 Steam Basmati Rice is a type of long-grain aromatic rice that is steamed before being milled. This process gives the rice a slightly softer texture and a more pronounced flavor than raw basmati rice. 1509 Steam Basmati Rice is also a good source of fiber and protein.
                                1509 Steam Basmati Rice is a popular choice for both everyday meals and special occasions. It is versatile and can be used to make a variety of dishes, including biryani, pilaf, pulao, and fried rice. It is also a good choice for risotto and other creamy rice dishes.
                                Here are some of the key characteristics of 1509 Steam Basmati Rice:
                                - Long, slender grains
                                - Soft texture
                                - Pronounced nutty flavor
                                - Good source of fiber and protein
                                - Versatile and can be used in a variety of dishes`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.35mm" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, Non-woven bag or  as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629691/1509-Raw-Rice_aick8u.jpg",
                    },
                    {

                        name: "1509 Raw Basmati Rice",
                        slug: "1509-row-basmati-rice",
                        desc: `1509 Raw Basmati Rice, also known as "1509 Basmati," is a premium variety of long-grain rice known for its exceptional aroma, flavor, and slender grains. Here's a detailed description of
                         1509 Raw Basmati Rice: Grain Characteristics: Grain Length: The grains of 1509 Raw Basmati Rice are exceptionally long, typically measuring between 8.2 to 8.4 millimeters. 
                         his long-grain characteristic is one of the defining features of Basmati rice. Grain Shape: The grains are slender, narrow, and pointed at one end, giving them an elegant appearance.
                          Grain Texture: The texture of 1509 Basmati rice is firm and non-sticky when cooked properly. Each grain remains separate, making it ideal for a variety of dishes.
                           Aroma:One of the most prized qualities of 1509 Raw Basmati Rice is its distinct and alluring aroma. When cooked, it emanates a delightful fragrance that is often described as nutty or floral,
                            with hints of earthiness. This aroma is what sets Basmati rice apart from other rice varieties. Flavor:The flavor of 1509 Basmati rice is rich, delicate, and slightly sweet. 
                        It complements a wide range of dishes and is especially popular in traditional Indian and Pakistani cuisine. Cultivation 
                        Region:1509 Basmati Rice is primarily grown in the fertile regions of India.particularly in the states of Haryana, Punjab, and Uttarakhand in India.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.35mm" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, Non-woven bag or  as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629691/1509-Sella-Rice_gxgmlr.jpg",
                    },
                    {
                        name: "1509 Sella Basmati Rice",
                        slug: "1509-sella-basmati-rice",
                        desc: `1509 Sella Basmati Rice" typically refers to a specific variety of Basmati rice known as "Pusa 1509" or "Pusa Sella." This variety was developed in India and is known for
                         its unique characteristics. Here are some details about Pusa 1509 Sella Basmati Rice: 1. Grain Characteristics: Grain Length: The grains of Pusa 1509 Sella Basmati Rice are long and slender, 
                         typically measuring between 7.5 to 8.0 millimeters in length. Grain Shape: The grains are slender and pointed, which is a defining feature of Basmati rice. 2. 
                         Color: The rice grains are typically creamy or golden in color. 3. Aroma and Flavor: Pusa 1509 Sella Basmati Rice is known for its strong and delightful aroma,
                          which is a combination of nutty and floral notes. It has a fragrant and aromatic flavor that enhances the overall dining experience.
                           4. Processing Method: "Sella" in the name indicates that this variety has undergone a parboiling process. During parboiling, the rice is partially boiled in the husk, 
                        which gelatinizes the starches and makes the grains less likely to break during cooking. It also contributes to the rice's characteristic aroma and elongated grains.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.35mm" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, Non-woven bag or  as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629691/1401-Sella-Rice_qecerl.jpg",
                    },
                    {
                        name: "1509 Golden Sella Basmati Rice",
                        slug: "1509-golden-sella-basmati-rice",
                        desc: `Grain Length: The grains of 1509 Golden Sella Basmati Rice are long, slender, and aromatic. The length of the grains typically ranges from 7.5 mm to 8.3 mm or even longer. 
                        Aroma: This rice is known for its natural and distinct Basmati aroma, which is often described as nutty or floral. Color: The rice grains have a golden or yellowish hue due to the 
                        parboiling process, which gives it the "Golden Sella" name. Texture: It is parboiled rice, so the grains are firm and separate when cooked. This makes it suitable for a variety of rice dishes where individual, fluffy grains are desired. Cooking Time: The cooking time for 1509 Golden Sella Basmati Rice is typically shorter compared to regular white Basmati rice due to 
                        the parboiling process. It may take approximately 15-20 minutes to cook, depending on the method used. Nutritional Value: Like other Basmati rice varieties, 1509 Golden Sella Basmati Rice retains some of the nutrients from the outer layers of the rice grain due to parboiling.
                         It is a good source of carbohydrates and provides energy. It is low in fat and gluten-free.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.40mm" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, Non-woven bag or  as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629690/1509-Golden-Sella_t1hg5h.jpg",
                    }
                ],
            },
            {
                name: "1401 Basmati Rice",
                slug: "1401-basmati-rice",
                desc: `1401 is an improved version of aromatic hybrid Basmati Rice. It is the first early maturing basmati rice variety & has high yield.
                 Experience the fine taste and the mouth-watering aroma of the 1401 Basmati Rice. Behold! These are not the only qualities associated with this newly developed variety of rice.
                  It's each and every grain cooks to perfection and the mere sight and smell make it hard to resist the urge to taste it. This variant of rice is an improved version of 
                  the hybrid aromatic basmati rice with an average grain length of 7.3 mm. This variety of rice is relatively newer and hence, much better than others. 
                  Our experts go the extra mile during the production of the 1401 Basmati Rice. 
                Order it now to taste the newly develop variety of rice, which also ranks among the best, and relish a taste like never before.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629690/1401-Raw_fh7cil.jpg",
                subitems: [
                    {
                        name: "1401 Steam Basmati Rice",
                        slug: "1401-steam-basmati-rice",
                        desc: `1401 Steam Basmati Rice is a type of long-grain aromatic rice that is steamed before being milled. This process gives the rice a slightly softer texture
                         and a more pronounced flavor than raw basmati rice. 1401 Steam Basmati Rice is also a good source of fiber and protein. It is a popular choice for both everyday 
                         meals and special occasions. It is versatile and can be used to make a variety of dishes, including biryani, pilaf, pulao, and fried rice. It is also a
                          good choice for risotto and other creamy rice dishes. Here are some of the key characteristics of 1401 Steam Basmati Rice: Long, 
                        slender grains Soft texture Pronounced nutty flavor Good source of fiber and protein Versatile and can be used in a variety of dishes`,
                        Specification: [
                            { "Purity": "95%" },
                            { "Natural Admixture": "5%" },
                            { "Average Grain Length": "7.70 MM" },
                            { "Moisture": "12.5% Max" },
                            { "Broken Grain": "1%" },
                            { "Damage/Discolour Grain": "1%" },
                            { "Immature Grain": "1%" },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bag, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629690/1401-Raw_fh7cil.jpg",
                    },
                    {
                        name: "1401 Raw Basmati Rice",
                        slug: "1401-raw-basmati-rice",
                        desc: `1401 Raw Basmati Rice, a testament to the pure and authentic Basmati experience. Harvested from the lush fields of India, 
                               this Basmati rice variety is a symbol of quality and tradition. Our 1401 Raw Basmati Rice is characterized by its long, slender grains,
                               each one embodying the essence of purity and natural goodness. Grown with care and precision, it retains the true aroma and taste of Basmati rice in its raw form.
                               This variety is perfect for those who appreciate the subtle nutty fragrance and delicate texture that only authentic Basmati can offer.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.70 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629691/1401-Sella-Rice_qecerl.jpg"
                    },
                    {
                        name: "1401 Sella Basmati Rice",
                        slug: "1401-sella-basmati-rice",
                        desc: `1401 Sella Basmati Rice, a true culinary treasure that embodies the essence of India's Basmati heritage. Sourced from the lush fields of India, this variety of Basmati rice is renowned for its exceptional qualities. Our 1401 Sella Basmati Rice boasts long, slender grains that remain separate and fluffy when cooked. What sets it apart is the special parboiling process it undergoes, which not only enhances its nutritional value but also results in a distinct aroma and taste. This rice variety is known for its ability to absorb flavors, making it a favorite for biryanis and pilafs.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.70 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629691/1401-Sella-Rice_qecerl.jpg"
                    },
                    {
                        name: "1401 Golden Sella Basmati Rice",
                        slug: "1401-golden-sella-basmati-rice",
                        desc: `1401 Golden Sella Basmati Rice, a true gem among grains. Sourced from the fertile fields of India, this Basmati rice variety is renowned for its superior quality and exceptional attributes. Our 1401 Golden Sella Basmati Rice stands out with its long, slender grains that remain separate and fluffy after cooking. What makes it truly special is the parboiling process it undergoes, which not only enriches its nutritional value but also imparts a beautiful golden hue. This rice variety has a distinct aroma and a rich, nutty flavor, making it a top choice for various culinary creations.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.70 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629695/1401-Golden-Sella_mxhfnw.jpg"
                    },

                ],
            },
            {
                name: "Pusa Basmati Rice",
                slug: "Pusa-basmati-rice",
                desc: `Pusa Raw Basmati Rice is a type of long-grain aromatic rice that is grown in the foothills of the Himalayas in India. It is a popular choice for both everyday meals and special occasions, and is known for its distinct nutty flavor and fluffy, non-sticky texture. Pusa Raw Basmati Rice is a good source of fiber and protein, and is also low in fat. It is a versatile rice that can be used to make a variety of dishes, including biryani, pilaf, pulao, and fried rice. It is also a good choice for risotto and other creamy rice dishes. Here are some of the key characteristics of Pusa Raw Basmati Rice: Long, slender
                       grains Distinct nutty flavor Fluffy, non-sticky texture Good source of fiber and protein Versatile and can be used in a variety of dishes`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629693/Pusa-Raw-Rice_kjwvxs.jpg",
                subitems: [
                    {
                        name: "Pusa Raw Basmati Rice",
                        slug: "pusa-raw-basmati-rice",
                        desc: `Pusa Raw Basmati Rice is a type of long-grain aromatic rice that is grown in the foothills of the Himalayas in India. It is a popular choice for both everyday meals and special occasions, and is known for its distinct nutty flavor and fluffy, non-sticky texture. Pusa Raw Basmati Rice is a good source of fiber and protein, and is also low in fat. It is a versatile rice that can be used to make a variety of dishes, including biryani, pilaf, pulao, and fried rice. It is also a good choice for risotto and other creamy rice dishes. 
                               To cook Pusa Raw Basmati Rice, simply rinse the rice in cold water until the water runs clear. Then, add the rice to a pot of boiling water and reduce the heat to low. Cover the pot and simmer for 15–20 minutes, or until the rice is cooked through. Once the rice is cooked, remove it from the heat and let it stand for 5 minutes before fluffing it with a fork.
                               Here are some tips for cooking Pusa Raw Basmati Rice:
                               • Rinse the rice thoroughly before cooking to remove any excess starch.
                               • Use a heavy-bottomed pot with a tight-fitting lid to prevent the rice from sticking to the bottom of the pot.
                               • Do not stir the rice while it is cooking. This can release starch and make the rice sticky.
                               • Once the rice is cooked, fluff it with a fork to separate the grains.
                               • Serve the rice immediately with your favorite dishes.`,
                        Specification: [
                            { "Purity": "95%" },
                            { "Natural Admixture": "5%" },
                            { "Average Grain Length": "7.45MM" },
                            { "Moisture": "12.5% Max" },
                            { "Broken Grain": "1%" },
                            { "Damage/Discolour Grain": "1%" },
                            { "Immature Grain": "1%" },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629693/Pusa-Raw-Rice_kjwvxs.jpg"
                    },

                    {
                        name: "Pusa Steam Basmati Rice",
                        slug: "pusa-steam-basmati-rice",
                        desc: `Pusa Basmati rice varieties are primarily grown in regions of India, including states like Haryana and Punjab. Versatility: Pusa Steam Basmati Rice is versatile and can be used in a wide range of rice-based dishes, including biryanis, pilafs, and other traditional Indian and international recipes. When purchasing Pusa Steam Basmati Rice or any other Basmati rice variety, it's essential to check for quality standards and certifications to ensure you are getting a high-quality product. The unique aroma and cooking properties of Basmati rice varieties, including Pusa Steam Basmati Rice, make them popular choices in many cuisines worldwide.
                               The term "Steam" in "Pusa Steam Basmati Rice" indicates that the rice has undergone a steaming process as part of its preparation. Steaming helps to partially cook the rice in its husk before milling. This process can enhance the aroma and make the grains firmer and less sticky when cooked compared to traditional white Basmati rice.
                               • Grain Length: Pusa Steam Basmati Rice is characterized by long, slender grains. The average grain length can range from 6.0 mm to 7.5 mm or longer.
                               • Aroma: Like all Basmati rice varieties, Pusa Steam Basmati Rice is known for its distinctive aroma, often described as nutty or floral. The steaming process can help preserve and enhance this aroma.
                               • Texture: The steaming process typically results in grains that are firmer and less likely to clump together when cooked. This makes it suitable for dishes where separate and fluffy grains are desired.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.45 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629697/Pusa-Steam-Rice_m9ybeb.jpg"
                    },

                    {
                        name: "Pusa Sella Basmati Rice",
                        slug: "pusa-sella-basmati-rice",
                        desc: `Pusa Basmati: "Pusa Basmati" is a group of Basmati rice varieties that have been developed through agricultural research and breeding. These varieties are characterized by their distinct Basmati aroma, long grains, and delicate flavor. They are named after the Pusa Institute of Technology in India, where these varieties were developed.
                               Sella Rice: The term "Sella" indicates that the rice has undergone a parboiling process as part of its preparation. Parboiling involves partially cooking the rice in its husk before milling. This process can help retain some of the nutrients from the outer layers of the rice grain and give the rice a golden or yellowish color. Sella Basmati rice is also known for its ability to remain separate and fluffy when cooked.
                               • Grain Length: Pusa Sella Basmati Rice is characterized by long, slender grains. The average grain length can range from 7.0 mm to 7.5 mm or longer.
                               • Aroma: Like all Basmati rice varieties, Pusa Sella Basmati Rice is known for its distinct aroma, often described as nutty or floral. The parboiling process can help preserve and enhance this aroma.
                               • Texture: Sella Basmati rice, including Pusa Sella, typically has a firm texture when cooked. The grains remain separate and do not stick together, making it ideal for dishes where individual, fluffy grains are desired.
                               • Cooking Time: The parboiling process reduces the cooking time for Pusa Sella Basmati Rice compared to regular white Basmati rice. It may take approximately 15-20 minutes to cook, depending on the cooking method used.
                               • Origin: Pusa Basmati rice varieties, including Pusa Sella, are primarily grown in regions of India, particularly in states like Haryana and Punjab.
                               • Versatility: Pusa Sella Basmati Rice is versatile and can be used in a wide range of rice-based dishes, including biryanis, pulao, and other traditional Indian and international recipes.
                               When purchasing Pusa Sella Basmati Rice or any other Basmati rice variety, it's essential to check for quality standards and certifications to ensure you are getting a high-quality product. The unique aroma and cooking properties of Basmati rice varieties, including Pusa Sella Basmati Rice, make them popular choices in many cuisines worldwide.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.45 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629693/Pusa-Sella-Rice_xv8rjo.jpg"
                    },

                    {
                        name: "Pusa Golden Sella Basmati Rice",
                        slug: "pusa-golden-sella-basmati-rice",
                        desc: `Pusa Basmati: "Pusa Basmati" refers to a group of Basmati rice varieties that have been developed through agricultural research and breeding. These varieties are characterized by their distinct Basmati aroma, long grains, and delicate flavor. They are named after the Pusa Institute of Technology in India, where these varieties were developed.
                               Golden Sella Rice: The term "Golden Sella" indicates that the rice has undergone a parboiling process as part of its preparation. Parboiling involves partially cooking the rice in its husk before milling. This process can help retain some of the nutrients from the outer layers of the rice grain and give the rice a golden or yellowish color. "Sella" also suggests that the rice is firm and separate when cooked.
                               • Grain Length: Pusa Golden Sella Basmati Rice is known for its long, slender grains. The average grain length can range from 7.0 mm to 7.5 mm or even longer.
                               • Aroma: Like all Basmati rice varieties, Pusa Golden Sella Basmati Rice is known for its distinct aroma, often described as nutty or floral. This aroma is one of the defining qualities of Basmati rice.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.45 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629692/Pusa-Golden-Sella_fqwkye.jpg"
                    }
                ],
            },
            {
                name: "Sharbati Basmati Rice",
                slug: "sharbati-basmati-rice",
                desc: `Sharbati Basmati Rice is a premium variety of Basmati rice known for its exceptional aroma, long grains,
                       and delicate flavor. It is primarily grown in the fertile regions of India, particularly in the states of Haryana 
                       and Punjab. Sharbati Basmati Rice is characterized by its slender, elongated grains that remain separate and fluffy 
                       when cooked. The rice has a distinct nutty aroma and a slightly sweet taste, making it a popular choice for various 
                       dishes, including biryanis, pulao, and fried rice. It is also known for its high nutritional value, being a good source 
                       of carbohydrates and essential nutrients.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629694/Sharbati-Raw_hdqtro.jpg",
                subitems: [
                    {
                        name: "Sharbati Basmati Raw Rice",
                        slug: "sharbati-basmati-raw-rice",
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629694/Sharbati-Raw_hdqtro.jpg", // Replace with actual Sharbati image if available
                        desc: `Sharbati Raw Rice is a type of long-grain aromatic rice that is grown in the northern Indian states of Punjab and Haryana. It is known for its sweet and nutty flavor, and its soft and fluffy texture. Sharbati Raw Rice is a popular choice for both everyday meals and special occasions.
                               Sharbati Raw Rice is a good source of fiber and protein, and is also low in fat. It is a versatile rice that can be used to make a variety of dishes, including biryani, pilaf, pulao, and fried rice. It is also a good choice for risotto and other creamy rice dishes.
                               **Key Characteristics:**
                               - Long, slender grains
                               - Sweet and nutty flavor
                               - Soft and fluffy texture
                               - Good source of fiber and protein
                               - Versatile and can be used in a variety of dishes`,
                        Specification: [
                            { "Purity": "95%" },
                            { "Natural Admixture": "5%" },
                            { "Average Grain Length": "7.10 MM" },
                            { "Moisture": "12.5% Max" },
                            { "Broken Grain": "2%" },
                            { "Damage/Discolour Grain": "2%" },
                            { "Immature Grain": "2%" },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice" }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ]
                    },
                    {
                        name: "Sharbati Steam Basmati Rice",
                        slug: "sharbati-steam-basmati-rice",
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629694/Sharbati-Steam_k2yqh0.jpg",
                       desc: `Sharbati Steam Basmati Rice is known for its long grains, soft texture, and mild aroma. Grown in North India, it’s perfect for daily meals like steamed rice, pulao, and fried rice.`,



                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.10 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ]
                    },

                    {
                        name: "Sharbati Sella Basmati Rice",
                        slug: "sharbati-sella-basmati-rice",
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629691/1509-Sella-Rice_gxgmlr.jpg",
                       desc: `Sharbati Sella Basmati Rice is parboiled for better nutrition and firm texture. With its long grains and mild aroma, it’s perfect for biryani, pulao, and daily meals.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.10 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ]
                    },
                    {
                        name: "Sharbati Golden Sella Basmati Rice",
                        slug: "sharbati-golden-sella-basmati-rice",
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629692/Pusa-Golden-Sella_fqwkye.jpg", // Replace with actual image if available
                       desc: `Sharbati Golden Sella Basmati Rice is known for its long grains, golden hue, and mild aroma. Parboiled for better nutrition and texture, this rice stays firm and fluffy when cooked. Grown in North India, it is an affordable and aromatic alternative to traditional Basmati, making it ideal for biryani, pulao, and everyday meals.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.10 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value Rice",
                            "Soft Texture Rice",
                            "Usage in Various Cuisines Food"
                        ]
                    }

                ],
            }
        ],
    },
    {
        category: "Indian Non Basmati Rice",
        desc: `Indian Non-Basmati Rice is a diverse category of rice varieties that are cultivated in India, distinct from the aromatic Basmati rice. 
               These non-basmati rice varieties are known for their unique flavors, textures, and culinary uses. They are widely consumed across the country and are often used in everyday meals, traditional dishes, and regional cuisines. 
               Some popular non-basmati rice varieties include IR64, PR11, Sona Masoori, and Ponni rice. Each variety has its own characteristics, making them suitable for different cooking methods and recipes.`,
        items: [
            {
                name: "PR 11 Rice",
                slug: "pr-11-rice",
                desc: `PR11 Rice is a non-basmati rice variety that is widely cultivated in India, particularly in the states of Punjab and Haryana. It is known for its medium grain size, soft texture, and affordability. PR11 Rice is commonly used in everyday meals and is a staple in many Indian households.
                       PR11 Rice is a popular choice for daily meals, economical export options, and is widely used in traditional Indian dishes such as khichdi, plain rice, and curries.
                       It cooks quickly and evenly, maintaining a soft texture. PR11 Rice is often preferred for its budget-friendly price and versatility in various cuisines.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747652177/PR-11_bxraks.jpg",
                subitems: [
                    {
                        name: "PR 11 Raw Rice",
                        slug: "pr-11-raw-rice",
                        desc: `PR11 Raw Rice is a popular non-basmati rice variety cultivated in northern India, especially in Punjab and Haryana. Known for its affordability, medium grain size, and soft texture after cooking, it is a staple in many households and food service operations.
                               This rice is preferred for daily meals, economical export options, and is widely used in traditional Indian dishes such as khichdi, plain rice, and curries. It cooks quickly and evenly, maintaining a soft texture.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "6.90 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "2% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, or as per buyer's choice" }
                        ],
                        knowFor: [
                            "Budget-Friendly Rice",
                            "Soft Texture",
                            "Popular Daily Use Rice",
                            "Quick Cooking",
                            "Widely Used in Indian Meals"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747652177/PR-11_bxraks.jpg"
                    },
                ]
            },
            {
                name: "PR 14 Rice",
                slug: "pr-14-rice",
                desc: `PR14 Rice is a non-basmati rice variety that is widely cultivated in India, particularly in the states of Punjab and Haryana. It is known for its medium grain size, soft texture, and affordability. PR14 Rice is commonly used in everyday meals and is a staple in many Indian households.
                       PR14 Rice is a popular choice for daily meals, economical export options, and is widely used in traditional Indian dishes such as khichdi, plain rice, and curries.
                       It cooks quickly and evenly, maintaining a soft texture. PR14 Rice is often preferred for its budget-friendly price and versatility in various cuisines.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747652176/PR-14_ykjr7p.jpg",
                subitems: [
                    {
                        name: "PR 14 Raw Rice",
                        slug: "pr-14-raw-rice",
                        desc: `PR14 Raw Rice is a popular non-basmati rice variety cultivated in northern India, especially in Punjab and Haryana. Known for its affordability, medium grain size, and soft texture after cooking, it is a staple in many households and food service operations.
                               This rice is preferred for daily meals, economical export options, and is widely used in traditional Indian dishes such as khichdi, plain rice, and curries. It cooks quickly and evenly, maintaining a soft texture.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "6.90 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "2% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, or as per buyer's choice" }
                        ],
                        knowFor: [
                            "Budget-Friendly Rice",
                            "Soft Texture",
                            "Popular Daily Use Rice",
                            "Quick Cooking",
                            "Widely Used in Indian Meals"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747652176/PR-14_ykjr7p.jpg"
                    }
                ]
            },
            {
                name: "IR 64 Rice",
                slug: "ir-64-rice",
                desc: `IR64 Rice is a popular non-basmati rice variety cultivated in India, particularly in the states of Andhra Pradesh and Tamil Nadu. It is known for its medium grain size, soft texture, and affordability. IR64 Rice is commonly used in everyday meals and is a staple in many Indian households.
                       IR64 Rice is a popular choice for daily meals, economical export options, and is widely used in traditional Indian dishes such as khichdi, plain rice, and curries. It cooks quickly and evenly, maintaining a soft texture. IR64 Rice is often preferred for its budget-friendly price and versatility in various cuisines.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747652176/IR-64_ym8lr4.jpg",
                subitems: [
                    {
                        name: "IR 64 Parboiled Rice",
                        slug: "ir-64-parboiled-rice",
                        desc: `IR64 Parboiled Rice is a popular non-basmati rice variety cultivated in southern India, especially in Andhra Pradesh and Tamil Nadu. Known for its affordability, medium grain size, and soft texture after cooking, it is a staple in many households and food service operations.
                               This rice is preferred for daily meals, economical export options, and is widely used in traditional Indian dishes such as khichdi, plain rice, and curries. It cooks quickly and evenly, maintaining a soft texture.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "6.90 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "2% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, or as per buyer's choice" }
                        ],
                        knowFor: [
                            "Budget-Friendly Rice",
                            "Soft Texture",
                            "Popular Daily Use Rice",
                            "Quick Cooking",
                            "Widely Used in Indian Meals"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747652176/IR-64_ym8lr4.jpg"
                    }
                ]
            },
            {
                name: "Sona Masoori Rice",
                desc: `Sona Masoori Rice is a popular non-basmati rice variety cultivated in southern India, particularly in the states of Andhra Pradesh and Karnataka. It is known for its medium grain size, soft texture, and aromatic flavor. Sona Masoori Rice is commonly used in everyday meals and is a staple in many Indian households.
                       Sona Masoori Rice is a popular choice for daily meals, economical export options, and is widely used in traditional Indian dishes such as biryani, pulao, and curries. It cooks quickly and evenly, maintaining a soft texture. Sona Masoori Rice is often preferred for its budget-friendly price and versatility in various cuisines.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747652176/Sona-Masoori-Rice_hobbgp.jpg",
                subitems: [
                    {
                        name: "Sona Masoori Raw Rice",
                        slug: "sona-masoori-raw-rice",
                        desc: `Sona Masoori Raw Rice is a popular non-basmati rice variety cultivated in southern India, particularly in the states of Andhra Pradesh and Karnataka. Known for its affordability, medium grain size, and soft texture after cooking, it is a staple in many households and food service operations.
                                 This rice is preferred for daily meals, economical export options, and is widely used in traditional Indian dishes such as khichdi, plain rice, and curries. It cooks quickly and evenly, maintaining a soft texture.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "6.90 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "2% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, or as per buyer's choice" }
                        ],
                        knowFor: [
                            "Budget-Friendly Rice",
                            "Soft Texture",
                            "Popular Daily Use Rice",
                            "Quick Cooking",
                            "Widely Used in Indian Meals"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1745917176/IR64_w8erum.jpg"
                    },
                ]
            },
            {
                name: "Jeera Kasala Rice",
                desc: `Jeera Kasala Rice is a non-basmati rice variety cultivated in India, particularly in the states of Maharashtra and Gujarat. It is known for its short to medium grain size, aromatic flavor, and unique cooking properties. Jeera Kasala Rice is commonly used in traditional Indian dishes and is appreciated for its distinct taste.
                          Jeera Kasala Rice is a popular choice for daily meals, economical export options, and is widely used in traditional Indian dishes such as biryani, pulao, and khichdi. It cooks quickly and evenly, maintaining a soft texture. Jeera Kasala Rice is often preferred for its aromatic flavor and versatility in various cuisines.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747652177/jeera-kasala_bxzqot.jpg",
                subitems: [
                    {
                        name: "Jeera Kasala Raw Rice",
                        slug: "jeera-kasala-raw-rice",
                        desc: `Jeera Kasala Raw Rice is a popular non-basmati rice variety cultivated in India, particularly in the states of Maharashtra and Gujarat. Known for its affordability, short to medium grain size, and aromatic flavor, it is a staple in many households and food service operations.
                                 This rice is preferred for daily meals, economical export options, and is widely used in traditional Indian dishes such as khichdi, plain rice, and curries. It cooks quickly and evenly, maintaining a soft texture.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "6.90 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "2% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, PP bag, or as per buyer's choice" }
                        ],
                        knowFor: [
                            "Budget-Friendly Rice",
                            "Soft Texture",
                            "Popular Daily Use Rice",
                            "Quick Cooking",
                            "Widely Used in Indian Meals"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747652177/jeera-kasala_bxzqot.jpgg",
                    },
                ]
            }
        ]
    },
    {
        category: "Pesticide-Free Rice",
        desc: `Pesticide-Free Rice is a type of rice that is cultivated without the use of synthetic pesticides or chemical fertilizers.
                This rice is grown using organic farming practices, which prioritize natural methods of pest control and soil enrichment. Pesticide-free rice is often considered healthier and more environmentally friendly compared to conventionally grown rice. It is available in various varieties, including Basmati and non-basmati types, and is popular among health-conscious consumers.`,
        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629693/1121-Steam-Rice_ou1fph.jpg",
        items: [
            {
                name: "Pesticide Residue Free Steam Rice",
                slug: "pesticide-residue-free-steam-rice",
                desc: `Pesticide Residue Free Steam Rice is a premium variety of rice that is cultivated without the use of synthetic pesticides or chemical fertilizers. This rice is processed using steam before milling, which enhances its flavor and texture while ensuring it is free from harmful residues.
                          Pesticide Residue Free Steam Rice is known for its long grains, aromatic flavor, and fluffy texture when cooked. It is a popular choice for health-conscious consumers and is often used in various culinary applications, including biryanis, pilafs, and steamed rice dishes.
                            This rice is available in both Basmati and non-basmati varieties, making it versatile for different cuisines. It is also appreciated for its nutritional benefits, as it retains essential vitamins and minerals during the steaming process.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629693/1121-Steam-Rice_ou1fph.jpg",
                subitems: [
                    {
                        name: "1121 Pesticide Residue Free Steam Rice",
                        slug: "1121-pesticide-residue-free-steam-rice",
                        desc: `1121 Pesticide Residue Free Steam Rice is renowned for its extra-long slender grains with a superior milled kernel length. It boasts the highest known kernel elongation ratio among all rice varieties. This rice emits a strong aroma and has received excellent ratings in cooking panel tests. With over 4x volume expansion upon cooking, it delivers more yield per quantity, making it highly preferred in households and the hotel industry.
                               It is artificially aged, meaning it can be consumed immediately without long-term storage. This avoids issues like insect infestation or rodent damage, making it more hygienic and cost-efficient. The rice is light on the stomach and ideal for preparing various types of Biryanis. Its popularity spans both Indian and Arab markets. Cultivated mainly in regions like J&K, Punjab, Haryana, Himachal Pradesh, Delhi, Uttarakhand, and Western Uttar Pradesh, it is a top-grade basmati variety.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.35 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value",
                            "Soft Texture",
                            "Usage in Various Cuisines",
                            "Ideal for Biryanis",
                            "Strong Aroma",
                            "More Cooked Volume from Less Rice"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629693/1121-Steam-Rice_ou1fph.jpg"
                    },
                    {
                        name: "1509 Pesticide Residue Free Steam Rice",
                        slug: "1509-pesticide-residue-free-steam-rice",
                        desc: `1509 Pesticide Residue Free Steam Rice is a premium long-grain aromatic rice that undergoes a steam process before milling, resulting in a soft texture and enhanced nutty flavor. Known for being high in fiber and protein, it is a popular choice for both daily meals and special culinary occasions.
                               This versatile rice is ideal for preparing biryani, pulao, pilaf, fried rice, risotto, and other creamy rice dishes. Its long, slender grains and light, fluffy texture make it a household and food service favorite. For best results, rinse thoroughly before cooking and simmer in a heavy-bottomed pot for 12–15 minutes.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.40 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Soft Texture",
                            "High Nutritional Value",
                            "Easy Cooking",
                            "Nutty Flavor",
                            "Used in Biryani, Pulao, Risotto & More"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629692/1509-Steam-Rice_kn9n9r.jpg"
                    }, {
                        name: "PUSA Basmati Pesticide Residue Free Steam Rice",
                        slug: "pusa-basmati-pesticide-residue-free-steam-rice",
                        desc: `PUSA Basmati Pesticide Residue Free Steam Rice is cultivated primarily in India's northern states like Haryana and Punjab. Known for its long, slender grains and captivating aroma, it is a versatile rice suitable for a variety of dishes including biryanis, pilafs, and traditional as well as international rice recipes.Steaming the rice before milling enhances its grain firmness, reduces stickiness, and boosts its signature aroma. With an average grain length of 7.45 mm and exceptional cooking properties, this rice is a preferred choice for both households and the hospitality industry. Always look for quality certifications to ensure you're purchasing an authentic high-grade PUSA rice variety.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.45 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Soft Texture",
                            "High Nutritional Value",
                            "Easy Cooking",
                            "Popular in Indian & International Dishes",
                            "Long, Slender Grains"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629697/Pusa-Steam-Rice_m9ybeb.jpg"
                    }, {
                        name: "Sharbati Pesticide Residue Free Steam Rice",
                        slug: "sharbati-pesticide-residue-free-steam-rice",
                        desc: `Sharbati Pesticide Residue Free Steam Rice undergoes a parboiling process, which partially cooks the rice in its husk before milling. This method helps retain nutrients from the outer layers and imparts a golden hue to the grain. The result is rice that cooks firm and non-sticky, with long, slender grains similar to Basmati.
Sharbati rice is known for its pleasant, nutty or floral aroma, making it a popular choice for pulao, biryani, and steamed rice. Though slightly less fragrant than Basmati, it delivers exceptional taste and texture. Grown primarily in Haryana and Punjab, this rice is suitable for both traditional and contemporary dishes. It pairs well with a variety of ingredients and reduces cooking time to approximately 15–20 minutes depending on the method.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.10 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Soft Texture",
                            "Nutty & Floral Aroma",
                            "Quick Cooking",
                            "Nutrient-Retaining Parboiled Process",
                            "Used in Biryani, Pulao, and Steamed Rice"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629694/Sharbati-Steam_k2yqh0.jpg"
                    }
                ]
            },
            {
                name: "Pesticide Residue Free Sella Rice",
                slug: "pesticide-residue-free-sella-rice",
                desc: `Pesticide Residue Free Sella Rice is a premium variety of rice that is cultivated without the use of synthetic pesticides or chemical fertilizers. This rice undergoes a parboiling process (Sella) before milling, which enhances its firmness, aroma, and nutrient retention while ensuring it is free from harmful residues.
Pesticide Residue Free Sella Rice is known for its long grains, rich aroma, and non-sticky texture when cooked. It is a popular choice for health-conscious consumers and is often used in various culinary applications including biryanis, pulao, and steamed rice dishes. Available in both Basmati and non-Basmati variants, it combines traditional flavor with modern processing for optimal quality.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629693/Pusa-Sella-Rice_xv8rjo.jpg",
                subitems: [
                    {
                        name: "1121 Pesticide Residue Free Sella Rice",
                        slug: "1121-pesticide-residue-free-sella-rice",
                        desc: `1121 Pesticide Residue Free Sella Rice is a premium variety of Basmati rice, highly prized for its exceptionally long grains, often measuring from 8.0 mm to 8.4 mm or even longer. This variety stands out for its nutty or floral aroma and is preferred in biryanis, pulao, and other rice-based dishes where each grain remains firm, non-sticky, and separate due to the parboiling (Sella) process.
Cultivated primarily in the Indian subcontinent, this rice type is processed through traditional breeding techniques and offers both superior taste and visual appeal. The 1121 Sella rice is ideal for consumers and chefs who demand both premium quality and consistent results in large-scale or gourmet cooking.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.35 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value",
                            "Firm Texture",
                            "Nutty & Floral Aroma",
                            "Ideal for Biryanis and Pulao"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629688/1121-Sella-Rice_kscsx3.jpg"
                    },
                    {
                        name: "1509 Pesticide Residue Free Sella Rice",
                        slug: "1509-pesticide-residue-free-sella-rice",
                        desc: `1509 Pesticide Residue Free Sella Rice is known for its long, slender grains (typically 7.5 to 8.0 mm), creamy or golden color, and exceptional non-sticky texture. Once cooked, the rice is fluffy with each grain remaining separate, making it an excellent choice for dishes like biryani and pilaf. 

Its strong and pleasant aroma—combining nutty and floral notes—adds to its culinary appeal. The grains are gelatinized through a parboiling process (Sella), which not only enhances their appearance and texture but also prevents breakage during cooking. This makes 1509 Sella Rice a preferred option for chefs and households alike.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.40 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value",
                            "Soft Texture",
                            "Non-Sticky & Fluffy When Cooked",
                            "Nutty & Floral Aroma",
                            "Used in Biryanis and Pilafs"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629695/1401-Golden-Sella_mxhfnw.jpg"
                    },
                    {
                        name: "PUSA Pesticide Residue Free Sella Rice",
                        slug: "pusa-pesticide-residue-free-sella-rice",
                        desc: `PUSA Pesticide Residue Free Sella Rice is a high-quality Basmati variety known for its long, slender grains and distinct nutty or floral aroma. Grown mainly in Haryana and Punjab, this rice undergoes a parboiling (Sella) process that enhances its cooking properties, allowing the grains to remain separate, fluffy, and firm even after cooking.

Due to this process, the rice cooks faster—typically within 15–20 minutes—while maintaining its aroma and nutritional profile. This makes it a preferred option for various Indian and international dishes like biryanis, pulao, and more. Its versatility, quick cooking time, and elegant texture make it a favorite among households and restaurants alike.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.45 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value",
                            "Soft Yet Firm Texture",
                            "Nutty & Floral Aroma",
                            "Ideal for Biryanis, Pulao, and Global Dishes"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629693/Pusa-Sella-Rice_xv8rjo.jpg"
                    },

                    {
                        name: "Sugandha Pesticide Residue Free Sella Rice",
                        slug: "sugandha-pesticide-residue-free-sella-rice",
                        desc: `Sugandha Pesticide Residue Free Sella Rice is an aromatic rice variety known for its long, slender grains and pleasant fragrance. While not a true Basmati variety, Sugandha rice is highly regarded for its nutty or floral aroma and is often used as an affordable alternative in many traditional recipes.

The 'Sella' parboiling process gives the rice a golden hue and helps retain nutrients from the outer grain layers. This method also improves the firmness of the rice, making the grains cook separately and preventing clumping. With a grain length typically ranging from 6.5 mm to 7.0 mm or longer, this rice is ideal for biryanis, pulao, and other flavored rice dishes where aroma and grain structure are important.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.90 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value",
                            "Firm, Non-Sticky Texture",
                            "Nutty & Floral Aroma",
                            "Used in Various Cuisines Globally"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629693/1121-Steam-Rice_ou1fph.jpg"
                    },
                    {
                        name: "Sharbati Pesticide Residue Free Sella Rice",
                        slug: "sharbati-pesticide-residue-free-sella-rice",
                        desc: `Sharbati Pesticide Residue Free Sella Rice is an aromatic non-Basmati rice variety known for its long, slender grains and pleasant nutty or floral aroma. Though not as fragrant as Basmati rice, it is highly valued for its consistent cooking performance and subtle flavor.

The parboiling (Sella) process helps retain essential nutrients and gives the rice a light golden hue. When cooked, Sharbati Sella Rice remains firm and non-sticky, making it ideal for dishes like biryani, pulao, and steamed rice preparations. It is a popular choice in both household and commercial kitchens due to its quality and affordability.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.10 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value",
                            "Firm & Non-Sticky Texture",
                            "Nutty & Floral Aroma",
                            "Versatile in Indian Cuisine"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629694/Sharbati-Raw_hdqtro.jpg"
                    }




                ]
            },


            {
                name: "Pesticide Residue Free Golden Sella Rice",
                slug: "pesticide-residue-free-golden-sella-rice",
                desc: `Its 100% safe as its not grown with any chemical or harmful pesticide. The nutrition value is high as compared to conventional rice. Its known and proven fact is golden. It is renowned for superfine kernels, great taste, exquisite aroma, and silky texture. The Sella rice is carefully nurtured to retain its complete nutritional value.`,
                imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629695/1121-Golden-Sella_tp7mog.jpg",
                subitems: [
                    {
                        name: "1121 Pesticide Residue Free Golden Sella Rice",
                        slug: "1121-pesticide-residue-free-golden-sella-rice",
                        desc: `1121 Pesticide Residue Free Golden Sella Rice is a premium variety of Basmati rice, celebrated globally for its extra-long grains, golden hue, and aromatic excellence. This rice undergoes a unique parboiling process that gives it a distinct golden color while enhancing its flavor, nutrition, and cooking performance.

Its long, slender grains remain separate and fluffy after cooking, making it a top choice for biryanis, pilafs, and special rice dishes. With a flavor profile that blends nutty, earthy, and slightly floral notes, this rice not only elevates the taste of meals but also adds a visually appealing elongation upon cooking — perfect for gourmet presentations.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.35 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value",
                            "Soft & Fluffy Texture",
                            "Nutty, Earthy & Floral Aroma",
                            "Ideal for Biryanis and Pilafs"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629695/1121-Golden-Sella_tp7mog.jpg"
                    },

                    {
                        name: "1509 Pesticide Residue Free Golden Sella Rice",
                        slug: "1509-pesticide-residue-free-golden-sella-rice",
                        desc: `1509 Pesticide Residue Free Golden Sella Rice is a popular choice for Indian and international cuisines, especially biryanis and other rice-based dishes that require separate, fluffy grains. It combines the traditional aroma and flavor of Basmati rice with the benefits of parboiling, making it less prone to breaking or clumping during cooking.

The parboiling process not only enhances its visual appeal with a golden hue but also helps retain key nutrients from the outer grain layers. With a grain length of around 8.4 mm and cooking time of 15–20 minutes, this variety offers excellent consistency and quality, making it ideal for both home kitchens and food service establishments.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "8.40 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value",
                            "Fluffy & Non-Sticky Texture",
                            "Golden Hue from Parboiling",
                            "Ideal for Biryanis and Global Cuisines"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629690/1509-Golden-Sella_t1hg5h.jpg"
                    }
                    ,
                    {
                        name: "Sugandha Pesticide Residue Free Golden Sella Rice",
                        slug: "sugandha-pesticide-residue-free-golden-sella-rice",
                        desc: `Sugandha Pesticide Residue Free Golden Sella Rice is a premium aromatic rice variety processed through a parboiling technique that gives it a rich golden hue. This method helps retain essential nutrients from the outer layers of the grain and ensures a firm, non-sticky texture when cooked.

Primarily grown in regions like Uttar Pradesh and Bihar, Sugandha Golden Sella Rice features long, slender grains with a distinct nutty and floral aroma. It is highly versatile and commonly used in Indian and global cuisines for dishes such as biryani, pulao, and plain steamed rice. Its ability to remain fluffy and separate after cooking makes it a favorite for both traditional and modern recipes.`,
                        Specification: [
                            { "Purity": "95.00%" },
                            { "Natural Admixture": "5.00%" },
                            { "Average Grain Length": "7.90 MM" },
                            { "Moisture": "12.5% Max." },
                            { "Broken Grain": "1% Max." },
                            { "Damage/Discolour Grain": "1% Max." },
                            { "Immature Grain": "1% Max." },
                            { "Foreign Matter": "Nil" },
                            { "Packaging Type": "Jute bag, BOPP Bags, PP bag, Non-woven bag or as per buyer's choice." }
                        ],
                        knowFor: [
                            "High Quality Rice",
                            "Easy Cooking Rice",
                            "High Nutritional Value",
                            "Golden Hue from Parboiling",
                            "Nutty & Floral Aroma",
                            "Perfect for Pulao, Biryani, and Steamed Rice"
                        ],
                        imgUrl: "https://res.cloudinary.com/dwfn4hylt/image/upload/v1747629692/Pusa-Golden-Sella_fqwkye.jpg"
                    }



                ]
            }

            
        ],
    },
];

export default productLinks;
